// extracted by mini-css-extract-plugin
module.exports = {"cell":"cell___27CoE","profile":"profile___CoVwH","table":"table___2lxBt"};